// 知识库api
import request from '@/axios'

/**
 * 获取知识库列表
 */
export function getKnowledgeList(data) {
  return request({
    url: '/inside/ai/knowledge/listBase',
    data
  })
}
/**
 * 获取知识库某分类目录下的列表
 */
export function getKnowledgeFolderList(data) {
  return request({
    url: '/inside/ai/knowledge/listCategory',
    data
  })
}
/**
 * 新建知识库
 */
export function createKnowledge(data) {
  return request({
    url: '/inside/ai/knowledge/saveBase',
    data
  })
}
/**
 * 修改知识库
 */
export function updateKnowledge(data) {
  return request({
    url: '/inside/ai/knowledge/updateBase',
    data
  })
}
/**
 * 删除知识库
 */
export function delKnowledge(data) {
  return request({
    url: '/inside/ai/knowledge/deleteBase',
    data
  })
}
/**
 * 获取知识库被引用信息
 */
export function getKnowledgeReference(data) {
  return request({
    url: '/inside/ai/knowledge/getDeleteBaseTag',
    data
  })
}

export function saveKnowledge(data) {
  return request({
    url: '/inside/ai/knowledge/save',
    data
  })
}

/**
 * 获取知识库文件列表
 * @param {Object} data - { knowledgeBaseId: 知识库ID, folderId: 文件夹ID（可选，不传则获取全部） }
 */
export function getKnowledgeFileList(data) {
  return request({
    url: '/inside/ai/knowledge/getFileList',
    data
  })
}

/**
 * 新建文件夹
 * @param {Object} data - { knowledgeBaseId: 知识库ID, folderId: 父文件夹ID, name: 文件夹名称 }
 */
export function createKnowledgeFolder(data) {
  return request({
    url: '/inside/ai/knowledge/saveCategory',
    data
  })
}

/**
 * 更新文件夹信息
 * @param {Object} data - { knowledgeBaseId: 知识库ID, folderId: 文件夹ID, name: 新名称 }
 */
export function updateKnowledgeFolder(data) {
  return request({
    url: '/inside/ai/knowledge/updateCategory',
    data
  })
}

/**
 * 上传文件至指定知识库目录
 * @param {Object} data
 */
export function uploadKnowledgeFile(data) {
  return request({
    url: '/inside/ai/knowledge/saveFile',
    data
  })
}

/**
 * 删除文件夹
 * @param {Object} data - { knowledgeBaseId: 知识库ID, folderId: 文件夹ID }
 */
export function deleteKnowledgeFolder(data) {
  return request({
    url: '/inside/ai/knowledge/deleteCategory',
    data
  })
}

/**
 * 移动文件
 * @param {Object} data - { knowledgeBaseId: 知识库ID, fileId: 文件ID, targetFolderId: 目标文件夹ID（null表示根目录） }
 */
export function moveKnowledgeFile(data) {
  return request({
    url: '/inside/ai/knowledge/moveFile',
    data
  })
}

/**
 * 删除文件
 * @param {Object} data - { knowledgeBaseId: 知识库ID, fileId: 文件ID, targetFolderId: 目标文件夹ID（null表示根目录） }
 */
export function deleteKnowledgeFile(data) {
  return request({
    url: '/inside/ai/knowledge/delFile',
    data
  })
}
